import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, Eye, Users, CalendarDays, Radio } from "lucide-react";

function StatCard({ icon: Icon, label, value, tone = "nv", testid }) {
  const color = tone === "red" ? "text-red-500" : "text-nv";
  return (
    <div className="border border-white/10 bg-[#0b0a09] p-5" data-testid={testid}>
      <div className="flex items-center gap-2 text-neutral-500 text-xs uppercase tracking-widest mb-2"><Icon className={`w-4 h-4 ${color}`} /> {label}</div>
      <p className="font-head text-3xl text-neutral-100">{value}</p>
    </div>
  );
}

export default function AdminVisits() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = () => api.get("/admin/visits/stats?days=14").then(({ data }) => setStats(data)).catch(() => {}).finally(() => setLoading(false));
    load();
    const id = setInterval(load, 20000);
    return () => clearInterval(id);
  }, []);

  if (loading) return <div className="p-4 text-neutral-500 flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Načítám…</div>;
  if (!stats) return <p className="text-neutral-600 text-sm">Statistiky se nepodařilo načíst.</p>;

  const maxViews = Math.max(1, ...stats.series.map((d) => d.views));

  return (
    <div className="space-y-6" data-testid="admin-visits">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard icon={Eye} label="Celkem zobrazení" value={stats.total_views} testid="stat-total-views" />
        <StatCard icon={Users} label="Unikátní návštěvníci" value={stats.unique_visitors} testid="stat-unique" />
        <StatCard icon={CalendarDays} label="Dnes" value={stats.today_views} testid="stat-today" />
        <StatCard icon={Radio} label="Právě online" value={stats.online_now} tone="red" testid="stat-online" />
      </div>

      <div className="border border-white/10 bg-[#0b0a09] p-5" data-testid="visits-chart">
        <p className="font-head text-sm text-nv tracking-widest uppercase mb-6">Návštěvnost — posledních 14 dní</p>
        <div className="flex items-end gap-2 h-48">
          {stats.series.map((d) => (
            <div key={d.date} className="flex-1 flex flex-col items-center justify-end group">
              <span className="text-[10px] text-neutral-400 mb-1 opacity-0 group-hover:opacity-100 transition-opacity">{d.views}</span>
              <div className={`w-full transition-colors border-t ${d.views > 0 ? "bg-nv/30 hover:bg-nv/60 border-nv" : "bg-white/5 border-white/10"}`} style={{ height: `${(d.views / maxViews) * 100}%`, minHeight: "2px" }} title={`${d.date}: ${d.views} zobrazení, ${d.unique} unikátních`} />
              <span className="text-[9px] text-neutral-600 mt-2 rotate-45 origin-left whitespace-nowrap">{d.date.slice(5)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
